<template lang="pug">
  v-layout.wrapper(row='' wrap='')
    main-banner
    v-flex(xs12 md4 sm6 offset-sm3 offset-md4)
      v-card.my-2.mx-4.subheading(flat)
        v-card-text.pb-0
          .red--text(
            v-if='badLogin'
            v-for='message in errorMessages'
            )
            | {{message}}
          v-layout(row='' wrap='')
            v-flex.wf-vertical-horizontal-center(xs1='')
            v-flex(xs11='')
              v-text-field#username(
                outline
                label='Email'
                v-model='username' 
                @keyup.enter='loginUser'
                :hint="hint"
              )
          v-layout(row='' wrap='')
            v-flex.wf-vertical-horizontal-center(xs1='')
            PasswordField#password(
              outline
              label='Password' 
              v-model='password' 
              @keyup.enter='loginUser'
              :hint="hint"
            )
          v-btn#login-button.full-width.ma-3(
            color='secondary' 
            @click='loginUser'
          )
            v-progress-circular(
              v-if="loggingIn"
              indeterminate
              color="white"
            )
            span( v-else )
              | Login
        v-card-actions.pb-5
          router-link#forgot-password-link.margin-auto.wf-link(
            :to='forgotPasswordPath'
          )
            | FORGOT PASSWORD

        div(
          class='subheading'
        ) OnCall Air Finance+ works best with the following browsers: 
          div
            a(target="_blank" href='https://www.apple.com/safari/') Safari 
            | | 
            a(target="_blank" href='https://www.google.com/chrome/') Chrome 
            | | 
            a(target="_blank" href='https://www.mozilla.org/en-US/firefox/') Firefox
</template>

<script>
  import { mapActions } from 'vuex'
  import MainBanner from 'Components/MainBanner.vue'
  import PasswordField from '@/components/PasswordTextField.vue'
  import LoginPage from 'Mixins/LoginPage.js'

  export default {
    name: 'login',
    components: {
      MainBanner,
      PasswordField,
    },
    mixins: [LoginPage],
    data () {
      return {
        username: '',
        password: '',
        forgotPasswordPath: '/forgot-password',
        badLoginWarning: '',
        badLogin: false,
        loggingIn: false,
        userFault: false
      }
    },
    computed: {
      //Compiling the messages we will display if there is an error.
      errorMessages(){
        return this.userFault ? [this.badLoginWarning, 'Please contact ops@creditforcomfort.com if problem persists.']: [this.badLoginWarning, 'Please contact ops@creditforcomfort.com']
      },
      hint() {
        return 'Note that this field is case-sensitive.'
      },
    },
    methods: {
      ...mapActions([
        'updateChangePasswordData',
      ]),
      loginUser () {
        //Set the default warning everytime we run this function
        this.userFault = false
        this.loggingIn = true
        const { username, password } = this
        const router = this.$router
        this.login({ username, password })
          .then((success) => {
            if (success === 'newUser') {
              router.push({ path: '/new-user-confirmation' })
            } else {
              this.getUserAndPlans()
            }
          }).catch((error) => {
            if(error.name === 'PasswordResetRequiredException'){
              this.updateChangePasswordData({ username, oldPassword: password })
                .then(()=>{
                  router.push({ path: '/forgot-password-change' })
                })
            } else if(error.name === 'UserNotFoundException'){
                if(error.message.includes('Incorrect username or password')){
                  this.badLoginWarning = 'Incorrect username and password combination'
              } else if (error.message.includes('Temporary password has expired')){
                  this.badLoginWarning = 'Your temporary password has expired and will need to be reset.'
              } else if (error.message.includes('Problem with this event for username')){
                  this.userFault = true
                  this.badLoginWarning = "We couldn't locate a user with this username. Double check your username's casing and spelling."
              } else {
                  this.badLoginWarning = 'Invalid Credentials'
              }
            } else if (error.name === 'NotAuthorizedException' && error.message === 'Incorrect username or password.'){
              this.userFault = true
              this.badLoginWarning = "Invalid password for this username. Double check your password's casing and spelling."
            } else {
              this.badLoginWarning = "Problem with login procedure."
            }
             
            this.badLogin = true
            this.loggingIn = false
          })
      }
    }
  }
</script>
<style scoped>

.v-text-field::v-deep .v-messages__message {
  color: #4b91e3;
}

.wrapper{
  height: 100%;
}
</style>